var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"alerts"},[_c('vue-headful',{attrs:{"title":_vm._f("formatTitle")(_vm.$t('TITLE_TYPE', { type: _vm.$tc('ALERT', 2) }))}}),_vm._v(" "),_c('alert-list'),_vm._v(" "),_c('router-view',{staticClass:"alerts__route"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }